export default "__VITE_PUBLIC_ASSET__78108a7d__"